import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {RouteObject} from '@github-ui/react-router'
import type {ComponentType} from 'react'

import {buildRepoAgentsRoute} from './repo-agents-route'

import {buildRepoTaskByIdRoute, buildRepoTaskRoute} from './task-route'

import {
  buildAutomationDetailRoute,
  buildAutomationHistoryRoute,
  buildAutomationRunsRoute,
  buildAutomationsRoute,
  buildEditAutomationRoute,
  buildNewAutomationRoute,
} from './automations-route'

export interface RepoAgentsRouteComponents {
  RepoAgentsPage: ComponentType
  TaskSuspended: ComponentType
  AutomationsPage: ComponentType
  AutomationDetailPage: ComponentType
  AutomationHistoryPage: ComponentType
  AutomationRunsPage: ComponentType
  EditAutomationPage: ComponentType
  NewAutomationPage: ComponentType
}

/**
 * Builds the Repository Agents route objects for a given app builder.
 *
 * Route configs are bound to the app builder that creates them (embedded-data
 * hydration + query-key app name), so registering these routes under a different
 * app (e.g. `repo`) requires rebuilding them with that app's builder rather than
 * importing the `repo-agents`-bound singletons directly.
 */
export function createRepoAgentsRoutes(
  appBuilder: DataRouterApplicationBuilder<string>,
  components: RepoAgentsRouteComponents,
): RouteObject[] {
  const {
    RepoAgentsPage,
    TaskSuspended,
    AutomationsPage,
    AutomationDetailPage,
    AutomationHistoryPage,
    AutomationRunsPage,
    EditAutomationPage,
    NewAutomationPage,
  } = components

  return [
    buildRepoAgentsRoute(appBuilder).toRoute({Component: RepoAgentsPage}),
    buildRepoTaskRoute(appBuilder).toRoute({Component: TaskSuspended}),
    buildRepoTaskByIdRoute(appBuilder).toRoute({Component: TaskSuspended}),
    buildAutomationsRoute(appBuilder).toRoute({Component: AutomationsPage}),
    buildNewAutomationRoute(appBuilder).toRoute({Component: NewAutomationPage}),
    buildEditAutomationRoute(appBuilder).toRoute({Component: EditAutomationPage}),
    buildAutomationDetailRoute(appBuilder).toRoute({Component: AutomationDetailPage}),
    buildAutomationHistoryRoute(appBuilder).toRoute({Component: AutomationHistoryPage}),
    buildAutomationRunsRoute(appBuilder).toRoute({Component: AutomationRunsPage}),
  ]
}
